<template>
<div>
  <div class="container-wide">
    <div v-if="get_loader" class="loader">
      <div class="j225 j228 j227 j224" style="width:50px;height:50px" role="progressbar">
        <svg class="j230" viewBox="22 22 44 44">
          <circle class="j231 j233" cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6"></circle>
        </svg>
      </div>
    </div>
    <Notification
      v-if="get_notification.message"
      :type="get_notification.type"
      :title="get_notification.title"
      @close="get_notification.message = false"
      :message="get_notification.message"/>
    <Header />
    <router-view></router-view>
    <Footer v-if="get_supplier.name!=='Rorschacherberg'"/>
  </div>
  <FooterRor v-if="get_supplier.name==='Rorschacherberg'"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/modules/02_header';
import Footer from '@/components/modules/04_footer';
import FooterRor from '@/components/modules/04b_footer_ror';
import Notification from '@/components/modules/05_notification';
require(process.env.SUPPLIER.scss.main);

export default {
  name: 'App',
  components: { Header, Footer, FooterRor, Notification },
  computed: {
    ...mapGetters(['get_steps', 'get_panels', 'get_supplier', 'get_notification', 'get_order_created', 'get_loader', 'get_selection']),
  },
  beforeCreate() {
     this.$store.commit('UPDATE_STORE');
  },
  created () {
      if (this.get_order_created) { 
          this.$store.dispatch('RESET_STATE');
      }
      window.addEventListener('beforeunload', this.unlockPanels);

  },
  methods: {
      unlockPanels() {
          const activePanels = this.get_selection.activePanels;
          if (activePanels.length && !this.get_order_created) {
              this.setPanelAvailable(activePanels.join());
          }
      },
      setPanelAvailable(panelId) {
          const selection = this.get_selection;
          const buildingId = selection.activeBuilding;
          const fieldId = selection.activeField;
          // sync call has to be used as we call it also on window.unload event
          const xhr = new XMLHttpRequest();
          const panelApiRoute = `${this.$apiUrl}/building/${buildingId}/field/${fieldId}/panel/available`;
          xhr.open('POST', panelApiRoute, false);
          let reqData = new FormData();
          reqData.append('panel_id', panelId);
          xhr.send(reqData);
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue